import React from 'react';
import { ShowWhatYouKnow } from 'dea-core';
import image from '../../assets/images/global-show-what-you-know.svg';
import voAudio from '../../assets/vo/Opioid-M-One-14.mp3';

const topic = 'the opioid epidemic';
const vo = {
  src: voAudio
};

export default {
  title: 'Show What You Learned',
  path: '/evaluate/show-what-you-learned',
  content: <ShowWhatYouKnow topic={topic} image={image} vo={vo} />
};



// WEBPACK FOOTER //
// ./src/data/evaluate/ShowWhatYouLearned.js